import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { STATUS_FLOW, STATUS_COLORS } from "../../lib/constants";
import { Link } from "react-router-dom";
import { Phone, Mail, MessageCircle, AlertCircle, Calendar } from "lucide-react";

export default function Kanban() {
  const [items, setItems] = useState([]);

  const load = () => api.get("/vertriebler/pipeline").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const grouped = STATUS_FLOW.reduce((acc, s) => {
    acc[s] = items.filter((i) => i.status === s);
    return acc;
  }, {});

  const heute = new Date(new Date().toDateString());

  return (
    <div className="space-y-5" data-testid="kanban-page">
      <div className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <h1 className="text-3xl font-heading font-bold text-falke-blue">Pipeline</h1>
          <p className="text-falke-anthracite/70">{items.length} Empfehlungen in Bearbeitung</p>
        </div>
        <Link to="/vertriebler/stats" className="btn-outline text-sm" data-testid="link-stats">Statistik ansehen</Link>
      </div>

      <div className="flex gap-3 overflow-x-auto pb-4" data-testid="kanban-columns">
        {STATUS_FLOW.map((status) => (
          <div key={status} className="kanban-col flex-shrink-0 w-72">
            <div className="flex items-center justify-between mb-3">
              <h3 className={`text-sm font-bold ${STATUS_COLORS[status]} px-2 py-1 rounded-md`}>{status}</h3>
              <span className="text-xs text-falke-blue/60 tabular font-semibold">{grouped[status].length}</span>
            </div>
            <div className="space-y-2 min-h-[60px]">
              {grouped[status].map((it) => {
                const wvUeberfaellig = it.wiedervorlage_am && new Date(it.wiedervorlage_am) < heute;
                return (
                  <div key={it.id} className="kanban-card" data-testid={`kanban-card-${it.id}`}>
                    <div className="flex items-start justify-between gap-2">
                      <div className="min-w-0">
                        <Link to={`/vertriebler/empfehlung/${it.id}`} className="font-semibold text-falke-blue text-sm truncate hover:text-falke-orange block" data-testid={`kanban-link-${it.id}`}>{it.empfohlener_name}</Link>
                        <div className="text-xs text-falke-anthracite/60 truncate">von {it.empfehler_name}{it.empfehler_modus === "gewerblich_aktiv" && <span className="ml-1 text-falke-orange font-semibold">·G</span>}</div>
                      </div>
                      {it.tage_im_status > 7 && (
                        <span className="text-rose-500" title={`${it.tage_im_status} Tage`}><AlertCircle size={14} /></span>
                      )}
                    </div>
                    {it.auftragswert_netto && (
                      <div className="text-xs text-falke-blue mt-1 tabular">€ {Number(it.auftragswert_netto).toFixed(0)} netto</div>
                    )}
                    {wvUeberfaellig && (
                      <div className="text-xs text-rose-600 mt-1 inline-flex items-center gap-1" title="Wiedervorlage überfällig">
                        <Calendar size={11} /> Wiedervorlage überfällig
                      </div>
                    )}
                    <div className="flex items-center gap-2 mt-2 text-falke-blue/70">
                      {it.empfohlener_telefon && <a href={`tel:${it.empfohlener_telefon}`} className="hover:text-falke-orange"><Phone size={13} /></a>}
                      {it.empfohlener_email && <a href={`mailto:${it.empfohlener_email}`} className="hover:text-falke-orange"><Mail size={13} /></a>}
                      {it.empfohlener_telefon && <a href={`https://wa.me/${it.empfohlener_telefon.replace(/\D/g, "")}`} target="_blank" rel="noreferrer" className="hover:text-falke-orange"><MessageCircle size={13} /></a>}
                      <Link to={`/vertriebler/empfehlung/${it.id}`} className="ml-auto text-falke-orange font-semibold text-xs hover:underline" data-testid={`btn-details-${it.id}`}>Details →</Link>
                    </div>
                  </div>
                );
              })}
              {grouped[status].length === 0 && <div className="text-xs text-falke-blue/40 py-4 text-center">—</div>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
